export default "__VITE_ASSET__RZqOSSiv__"